// extracted by mini-css-extract-plugin
export default {"Swiper_div":"Swiperrr_Swiper_div__Sohiq"};